
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ChevronDown, ChevronUp, GripVertical } from 'lucide-react';
import { Draggable } from 'react-beautiful-dnd';

interface BaseWidgetProps {
  id: string;
  title: string;
  index: number;
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
  children: React.ReactNode;
  className?: string;
}

const BaseWidget = ({ 
  id, 
  title, 
  index, 
  isCollapsed = false, 
  onToggleCollapse, 
  children, 
  className = '' 
}: BaseWidgetProps) => {
  return (
    <Draggable draggableId={id} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          className={`${className} ${snapshot.isDragging ? 'opacity-75' : ''}`}
        >
          <Card className="bg-white shadow-luxury border-juv-rose-clay/30">
            <CardHeader className="pb-3">
              <CardTitle className="flex items-center justify-between text-juv-deep-chestnut">
                <div className="flex items-center space-x-2">
                  <div {...provided.dragHandleProps} className="cursor-grab">
                    <GripVertical className="h-4 w-4 text-gray-400" />
                  </div>
                  <span className="font-juv-heading">{title}</span>
                </div>
                {onToggleCollapse && (
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={onToggleCollapse}
                    className="h-6 w-6 p-0"
                  >
                    {isCollapsed ? (
                      <ChevronDown className="h-4 w-4" />
                    ) : (
                      <ChevronUp className="h-4 w-4" />
                    )}
                  </Button>
                )}
              </CardTitle>
            </CardHeader>
            {!isCollapsed && (
              <CardContent>
                {children}
              </CardContent>
            )}
          </Card>
        </div>
      )}
    </Draggable>
  );
};

export default BaseWidget;
